// extracted by mini-css-extract-plugin
export default {"item":"product-item_item__Xrfb6","productItem":"product-item_productItem__oAwHi"};